import { Action, ACTION_TYPE, ERROR_CODE } from '@abiglobalhealth/go-types'

import { actionsRequest } from '@/api/utils'

export const updateUser = async <T extends Action<ACTION_TYPE.UPDATE_USER>>({ user }: T['payload']): Promise<T['response']> => {
  if (!user) throw new Error('User not found on update')

  const body = await actionsRequest<T>({
    payload: {
      user
    },
    type: ACTION_TYPE.UPDATE_USER
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  const updatedUser = body.data
  if (!updatedUser) throw new Error(ERROR_CODE.USER_NOT_FOUND)

  return updatedUser
}

export const createUser = async <T extends Action<ACTION_TYPE.CREATE_USER>>({ user }: T['payload']): Promise<T['response']> => {
  if (!user) throw new Error('User not found on creation')

  const body = await actionsRequest<T>({
    payload: {
      user
    },
    type: ACTION_TYPE.CREATE_USER
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  const createdUser = body.data
  if (!createdUser) throw new Error(ERROR_CODE.USER_NOT_FOUND)

  return createdUser
}

export const getUser = async <T extends Action<ACTION_TYPE.GET_USER>>({ userId }: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload: {
      userId
    },
    type: ACTION_TYPE.GET_USER
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  const user = body.data

  return user
}

export const getRouteConditions = async <T extends Action<ACTION_TYPE.GET_ROUTE_CONDITIONS>>({
  uniqueId,
  type
}: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload: {
      uniqueId,
      type
    },
    type: ACTION_TYPE.GET_ROUTE_CONDITIONS
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}

export const setUserInfo = async <T extends Action<ACTION_TYPE.SET_USER_INFO>>(data: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload: data,
    type: ACTION_TYPE.SET_USER_INFO
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}
export const setFulfillmentUserAddress = async <T extends Action<ACTION_TYPE.SET_FULFILLMENT_USER_ADDRESS>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.SET_FULFILLMENT_USER_ADDRESS
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}
export const updateUserLanguage = async <T extends Action<ACTION_TYPE.UPDATE_USER_LANGUAGE>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.UPDATE_USER_LANGUAGE
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}
export const setFulfillmentPatientInfo = async <T extends Action<ACTION_TYPE.SET_FULFILLMENT_PATIENT_INFO>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.SET_FULFILLMENT_PATIENT_INFO
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}
